export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives8.50420b9d.jpg";